export function getIconContent(variant: "normal" | "error") {
  return variant === "normal"
    ? `<svg width="16" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" width="16" height="16" rx="8" fill="#3DAC3F"/>
<g clip-path="url(#clip0_3314_27028)">
<path d="M7.24993 9.7373L5.8041 8.29147C5.6416 8.12897 5.3791 8.12897 5.2166 8.29147C5.0541 8.45397 5.0541 8.71647 5.2166 8.87897L6.95827 10.6206C7.12077 10.7831 7.38327 10.7831 7.54577 10.6206L11.9541 6.2123C12.1166 6.0498 12.1166 5.7873 11.9541 5.6248C11.7916 5.4623 11.5291 5.4623 11.3666 5.6248L7.24993 9.7373Z" fill="#FDFDFE"/>
</g>
<defs>
<clipPath id="clip0_3314_27028">
<rect width="10" height="10" fill="white" transform="translate(3.5 3)"/>
</clipPath>
</defs>
</svg>`
    : `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="16" height="16" rx="8" fill="#FE320E"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.0887 4.91129C11.2413 5.06383 11.2413 5.31117 11.0887 5.46371L5.46371 11.0887C5.31117 11.2413 5.06383 11.2413 4.91129 11.0887C4.75874 10.9362 4.75874 10.6888 4.91129 10.5363L10.5363 4.91129C10.6888 4.75874 10.9362 4.75874 11.0887 4.91129Z" fill="#FDFDFE"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.91129 4.91129C5.06383 4.75874 5.31117 4.75874 5.46371 4.91129L11.0887 10.5363C11.2413 10.6888 11.2413 10.9362 11.0887 11.0887C10.9362 11.2413 10.6888 11.2413 10.5363 11.0887L4.91129 5.46371C4.75874 5.31117 4.75874 5.06383 4.91129 4.91129Z" fill="#FDFDFE"/>
</svg>`;
}
